<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <h2>{{ $t('shop.selected_product') }}</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mb-2">
                <div class="selected-product-row pb-1">
                    <h3
                        class="text-primary"
                        v-html="
                            (
                                selectedProductType === 'route_toll'
                                    ? $t('shop.toll-product')
                                    : (
                                        selectedProduct
                                            ? vignetteProducts[selectedProduct]?.name
                                            : $t('shop.selected_product_choose')
                                    )
                            )
                        "
                    ></h3>
                    <p
                        v-html="
                            (
                                selectedProductType === 'route_toll'
                                    ? $t('shop.toll-description')
                                    : (
                                        selectedProduct
                                            ? vignetteProducts[selectedProduct]?.description
                                            : $t('shop.selected_product_description')
                                    )
                            )
                        "
                    ></p>
                    <a
                        v-if="changeProductSetting === true"
                        class="toggle-package-change clickable"
                        :class="
                            (selectedProductType !== 'route_toll' && selectedProduct <= 0) || showPackageChange
                                ? 'turned'
                                : ''
                        "
                        @click="togglePackageChange"
                    >
                        {{ $t('shop.selected_product_change') }} <i class="mdi mdi-chevron-down"></i>
                    </a>
                </div>

                <div
                    class="row shop-pricing"
                    v-if="
                        !showPackageChange &&
                        selectedProduct &&
                        selectedShopProduct &&
                        isMobile
                    "
                >
                    <div class="col-lg-3 my-lg-0 col-md-6 my-md-1 vignette">
                        <VignetteProductCard
                            v-bind="selectedShopProduct"
                            :options="selectedShopProduct.options"
                            :key="selectedShopProduct.id"
                            :smaller-view="false"
                            :ref="'product-card-' + selectedShopProduct.id"
                            :selected-product="selectedProduct"
                            :url-name="selectedShopProduct.url_name"
                            :url-names="selectedShopProduct.urls"
                            :config-value="currentOrderValue"
                            v-on:product-card-selected="changeSelection"
                            :selected-product-type="selectedProductType"
                        ></VignetteProductCard>
                    </div>
                </div>

                <div
                    class="row shop-pricing"
                    :class="{
                        'd-none': !(
                            (selectedProductType !== 'route_toll' && selectedProduct <= 0) ||
                            showPackageChange
                        ),
                    }"
                >
                    <div
                        v-for="product in visibleProducts"
                        :key="product.id"
                        class="col-lg-3 my-lg-0 col-md-6 my-md-1 vignette"
                    >
                        <VignetteProductCard
                            v-bind="product"
                            :smaller-view="false"
                            :ref="'product-card-' + product.id"
                            :config-value="currentOrderValue"
                            :selected-product="selectedProduct"
                            :url-name="product.url_name"
                            :url-names="product.urls"
                            :preselect-id="
                                defaultSelectedProduct !== null &&
                                defaultSelectedProduct.productType === 'vignette'
                                    ? defaultSelectedProduct.id
                                    : null
                            "
                            v-on:product-card-selected="changeSelection"
                            :selected-product-type="selectedProductType"
                            :notice-popup="product.noticePopup"
                        ></VignetteProductCard>
                    </div>

                    <div
                        v-if="typeof hideRouteTollProducts !== 'boolean' || !hideRouteTollProducts"
                        class="col-lg-3 my-lg-0 col-md-6 my-md-1 route-toll"
                    >
                        <TollProductCard
                            :selected-product="selectedProduct"
                            :preselect-id="
                                defaultSelectedProduct !== null &&
                                defaultSelectedProduct.productType === 'route_toll'
                            "
                            :url-name="routeTollProduct.url_name"
                            :url-names="routeTollProduct.urls"
                            v-on:product-card-selected="changeSelection"
                            :selected-product-type="selectedProductType"
                            :smaller-view="false"
                            :config-value="currentOrderValue"
                            :start-price="tollProductsStartPrice"
                            :notice-popup="null"
                        ></TollProductCard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TollProductCard from '../../../components/TollProductCard.vue';
import VignetteProductCard from '../../../components/VignetteProductCard.vue';

export default {
    name: 'OrderFormProductSelection',
    components: {
        TollProductCard,
        VignetteProductCard,
    },

    props: [
        'vignetteProducts',
        'defaultSelectedProduct',
        'defaultSelectedOption',
        'changeProductSetting',
        'currentOrderValue',
        'isMobile',
        'hideRouteTollProducts',
        'tollProductsStartPrice',
        'routeTollProduct',
        'selectedRoute',
        'options',
        'selectedTollOption',
        'tollProducts',
    ],

    data() {
        return {
            selectedProduct: null,
            selectedProductType: '',
            selectedProductUrlName: '',
            selectedProductUrlNames: {},
            showPackageChange: false,
            scrollToProduct: false,
            initialScroll: true,
        };
    },

    mounted() {
        this.showPackageChange = !this.isMobile;
    },

    computed: {
        selectedShopProduct() {
            if (this.selectedProduct === null) {
                return null;
            }

            switch (this.selectedProductType) {
                case 'vignette':
                    return this.vignetteProducts[this.selectedProduct] ?? null;

                case 'route_toll':
                    return this.tollProducts[this.selectedProduct] ?? Object.values(this.tollProducts)[0] ?? null;

                default:
                    return null;
            }
        },

        visibleProducts() {
            return Object.values(this.vignetteProducts)
                .sort((a,b) => a.product_sort-b.product_sort);
        },

        isSubscriptionEnabled() {
            switch (this.selectedProductType) {
                case 'route_toll':
                    return (
                        this.options &&
                            typeof this.options[this.selectedTollOption] === 'object' &&
                            this.options[this.selectedTollOption] !== null &&
                            typeof this.options[this.selectedTollOption].enable_subscription === 'boolean' &&
                            this.options[this.selectedTollOption].enable_subscription
                    );

                default:
                    return (
                        this.selectedShopProduct !== null &&
                            typeof this.selectedShopProduct.enable_subscription === 'boolean' &&
                            this.selectedShopProduct.enable_subscription
                    );
            }
        },
    },

    watch: {
        selectedProduct(val) {
            this.updateField('selectedProduct', val);
            this.$emit('product-selected');
        },

        selectedShopProduct(val) {
            this.updateField('selectedShopProduct', val);
            this.$emit('product-selected');
        },

        selectedProductType(val) {
            this.updateField('selectedProductType', val);
        },

        selectedProductUrlName(val) {
            this.updateField('selectedProductUrlName', val);
        },

        selectedProductUrlNames(val) {
            this.updateField('selectedProductUrlNames', val);
        },

        isSubscriptionEnabled(val) {
            this.updateField('isSubscriptionEnabled', val);
        },
    },

    methods: {
        updateField(field, value) {
            this.$emit('field-updated', {field: field, value: value});
        },

        saveToSession(key, value, type) {
            this.$emit('save-to-session', {key, value, type});
        },

        changeSelection(source) {
            const prevProduct = this.selectedProduct,
                prevUrlName = this.selectedProductUrlName,
                prevUrlNames = this.selectedProductUrlNames;

            this.selectedProduct = source.id;
            this.selectedProductType = source.type;
            this.selectedProductUrlName = source.urlName || '';
            this.selectedProductUrlNames = source.urlNames || {};

            if (this.selectedProductType === 'route_toll') {
                if (this.selectedRoute > 0) {
                    this.selectedProduct = this.selectedRoute;
                } else if (Object.keys(this.tollProducts).length > 0) {
                    this.selectedProduct = parseInt(Object.keys(this.tollProducts)[0]);
                }
            }

            this.$emit('product-selected');
            this.$emit('show-loading-animation');
            this.$emit('input-change');

            if (this.selectedProductType === 'route_toll') {
                this.$emit('display-route-options');
            } else if (prevProduct !== this.selectedProduct) {
                this.$emit('display-type-options');
            }

            if (this.selectedProductType === 'vignette') {
                const paymentSubscription = this.isSubscriptionEnabled && this.selectedShopProduct.subscription_by_default;
                this.updateField('paymentSubscription', paymentSubscription);
            }

            this.saveToSession('selectedProduct', 'string', this.selectedProduct);
            this.saveToSession('selectedProductType', 'string', this.selectedProductType);

            setTimeout(() => {
                this.$emit('preselect-route-toll-option');
                window.dispatchEvent(new Event('resize'));
                this.$emit('init-tool-tip');
            }, 10);

            this.handleProductScrolling();

            setTimeout(() => {
                this.updateStructuredProductData();
                this.updateProductMetadata(prevUrlName, prevUrlNames);
            }, 50);

            // In the case the product has an url_name definition, we should update
            // the history of browser to give the user a history back option.
            if (
                typeof source.urlName === 'string' &&
                source.urlName.length &&
                source.urlName !== '#' &&
                window.history &&
                !window.location.pathname.endsWith(source.urlName)
            ) {
                // Default history target url
                const baseUrl = window.location.href + (window.location.href.endsWith('/') ? '' : '/');
                let historyUrl = baseUrl + source.urlName;

                // In the case we have an previous url name, we should replace the old one.
                if (typeof prevUrlName === 'string' && prevUrlName.length) {
                    historyUrl = window.location.href.replace(prevUrlName, source.urlName);
                }

                if (this.defaultSelectedOption > 0) {
                    // Do nothing. This URL is only directly reachable by the configurator.
                } else {
                    window.history.pushState('', '', historyUrl);
                }

                // In the case that the product has multiple url translations, we should
                // update the locales in the #locales-submenu.
                if (typeof source.urlNames === 'object' && (Object.keys(source.urlNames) || []).length) {
                    const navItems = document.querySelectorAll('#locales-submenu li');

                    for (const navItem of navItems) {
                        const locale = navItem.dataset.locale,
                            link = navItem.querySelector('a'),
                            oldSlugName = prevUrlNames[locale] || null,
                            newSlugName = source.urlNames[locale] || null;

                        // We're not able to handle the update of url
                        if (
                            typeof oldSlugName !== 'string' ||
                            !oldSlugName.length ||
                            typeof newSlugName !== 'string' ||
                            !newSlugName.length
                        ) {
                            return;
                        }

                        link.href = link.href.replace(oldSlugName, newSlugName);
                    }
                }
            }
        },

        togglePackageChange()  {
            this.showPackageChange = !this.showPackageChange;
        },

        getAnchorTag() {
            return window.location.hash;
        },

        handleProductScrolling() {
            const anchorTag = this.getAnchorTag();
            let scrollSelector = null;

            if (
                !anchorTag ||
                this.scrollToProduct
            ) {
                this.showPackageChange = false;
                scrollSelector = '#optionSelection';
            } else if (!this.scrollToProduct) {
                this.scrollToProduct = true;
                scrollSelector = anchorTag;
            }

            this.$nextTick(
                () => {
                    setTimeout(() => {
                        if (this.initialScroll) {
                            this.initialScroll = false;
                        }

                        let scrollY = document.querySelector(scrollSelector).getBoundingClientRect().top -
                            document.getElementById('topnav').getBoundingClientRect().height;

                        if (this.selectedProductType === 'vignette') {
                            scrollY += window.scrollY;
                        }
                        window.scrollTo(0, scrollY);
                    }, this.initialScroll ? 50 : 100);
                }
            );
        },

        updateStructuredProductData() {
            const structuredDataStore = document.querySelector('#structured-product');

            if (structuredDataStore === null) {
                return;
            }

            let product = null;

            if (this.selectedProductType === 'vignette') {
                product = this.vignetteProducts[this.selectedProduct] ?? null;
            } else if (this.selectedProductType === 'route_toll') {
                product = this.tollProducts[this.selectedProduct] ?? null;
            }

            if (product === null || typeof(product.metadata) !== 'object') {
                structuredDataStore.innerText = '';
                return;
            }

            // Replace the description content if available at the product.
            const description = document.querySelector('#description');
            description.innerHTML = product.metadata.shopDescription ?? '';

            structuredDataStore.innerText = JSON.stringify(product.metadata.structuredData);
        },

        updateProductMetadata(prevUrlName, prevUrlNames) {
            let product = null;

            if (this.selectedProductType === 'vignette') {
                product = this.vignetteProducts[this.selectedProduct] ?? null;
            } else if (this.selectedProductType === 'route_toll') {
                product = this.tollProducts[this.selectedProduct] ?? null;
            }

            if (!product) {
                return;
            }

            let title = this.$t('meta.title');
            if (product.meta_title && product.meta_title.length > 0) {
                title = product.meta_title;
            }

            document.title = title;
            document.querySelector('meta[name="title"]')
                .setAttribute('content', title);

            let description = this.$t('meta.description');
            if (product.meta_description && product.meta_description.length > 0) {
                description = product.meta_description;
            }

            document.querySelector('meta[name="description"]')
                .setAttribute('content', description);

            if (prevUrlName && prevUrlNames) {
                const defaultLanguage = 'en';

                document.querySelectorAll('link[rel="canonical"]').forEach((link) => {
                    link.href = link.href.replace(prevUrlName, this.selectedProductUrlName);
                });

                document.querySelectorAll('link[rel="alternate"]').forEach((link) => {
                    const lang = link.getAttribute('hreflang');
                    if (lang === 'x-default') {
                        link.href = link.href.replace(prevUrlNames[defaultLanguage], this.selectedProductUrlNames[defaultLanguage]);
                    } else if (this.selectedProductUrlNames[lang]) {
                        link.href = link.href.replace(prevUrlNames[lang], this.selectedProductUrlNames[lang]);
                    } else if (!this.selectedProductUrlNames[lang] && this.selectedProductUrlNames[defaultLanguage]) {
                        link.href = link.href.replace(prevUrlNames[lang], this.selectedProductUrlNames[defaultLanguage]);
                    } else {
                        link.href = '';
                    }
                });
            }
        },
    },
};
</script>
